/* eslint-disable flowtype/require-valid-file-annotation */
/* eslint-disable react/no-multi-comp */

import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Button from 'material-ui/Button';
import Avatar from 'material-ui/Avatar';
import List, { ListItem, ListItemText, ListItemSecondaryAction } from 'material-ui/List';
import Dialog, { DialogTitle } from 'material-ui/Dialog';
import blue from 'material-ui/colors/blue';
import Checkbox from 'material-ui/Checkbox';

const relations = ['Nicole Couture', 'Serge Lebeau'];
const styles = {
    avatar: {
        background: blue[100],
        color: blue[600],
    },
};

class SimpleDialog extends React.Component {
    sharedRelations = [];

    state = {
        checked: [],
    };

    handleRequestClose = () => {
        this.props.onRequestClose(this.props.selectedValue);
        this.setState({
            checked: [],
        });
    };

    handleToggle = value => () => {
        const { checked } = this.state;
        const currentIndex = checked.indexOf(value);
        const newChecked = [...checked];

        if (currentIndex === -1) {
            newChecked.push(value);
            this.sharedRelations = newChecked;
        } else {
            newChecked.splice(currentIndex, 1);
            this.sharedRelations = newChecked;
        }

        this.setState({
            checked: newChecked,
        });
    };

    render() {
        const { classes, onRequestClose, selectedValue, ...other } = this.props;

        return (
            <Dialog onRequestClose={this.handleRequestClose} {...other}>
                <DialogTitle className="shared-dialog-title">Share with:</DialogTitle>
                <div className="shared-list">
                    <List>
                        {relations.map(value => (
                            <ListItem key={value} dense button className={"shared-relations"} onClick={this.handleToggle(value)}>
                                <Avatar>M</Avatar>
                                <ListItemText primary={value} />
                                <ListItemSecondaryAction>
                                    <Checkbox
                                        onChange={this.handleToggle(value)}
                                        checked={this.state.checked.indexOf(value) !== -1}
                                    />
                                </ListItemSecondaryAction>
                            </ListItem>
                        ))}
                    </List>
                    <Button center="center" label="Default" className="hw-primary-btn" onClick={this.handleRequestClose}>Share</Button>
                </div>
            </Dialog>
        );
    }
}

SimpleDialog.propTypes = {
    classes: PropTypes.object.isRequired,
    onRequestClose: PropTypes.func,
    selectedValue: PropTypes.string,
};

const GraphShareBtnWrapped = withStyles(styles)(SimpleDialog);

class GraphShareBtn extends React.Component {
    state = {
        open: false,
        selectedValue: relations[1],
    };

    handleClickOpen = () => {
        this.setState({
            open: true,
        });
    };

    handleRequestClose = value => {
        this.setState({ selectedValue: value, open: false });
    };

    render() {
        return (
            <span>
                <Button raised color="primary" className="share" onClick={this.handleClickOpen}>Share</Button>
                <GraphShareBtnWrapped
                    selectedValue={this.state.selectedValue}
                    open={this.state.open}
                    onRequestClose={this.handleRequestClose}
                />
            </span>
        );
    }
}

export default GraphShareBtn;


// WEBPACK FOOTER //
// ./src/components/ShareModal.js